import React, { createContext, useContext } from 'react'

const YourekoContext = createContext(false)

const YourekoProvider = ({ isYourekoEnabled, children }) => (
  <YourekoContext.Provider value={isYourekoEnabled}>{children}</YourekoContext.Provider>
)

// For Functional Components
const useYourekoContext = () => {
  const context = useContext(YourekoContext)
  if (context === undefined) {
    throw new Error('useYourekoContext must be used within a YourekoProvider')
  }
  return context
}

export { YourekoContext, YourekoProvider, useYourekoContext }
